const inlineRuns = node => {
  const runs = [];
  const visit = (item, bold = false, italic = false) => {
    if (item.nodeType === 3) {
      runs.push({ text: item.textContent, bold, italic });
      return;
    }
    const tag = (item.tagName || "").toLowerCase();
    if (["script", "style"].includes(tag)) return;
    if (tag === "br") runs.push({ text: " ", bold, italic });
    const computed =
      item.nodeType === 1
        ? item.ownerDocument?.defaultView?.getComputedStyle(item)
        : null;
    const weight = item.style?.fontWeight || computed?.fontWeight || "";
    const nextBold =
      bold ||
      ["b", "strong"].includes(tag) ||
      weight === "bold" ||
      Number(weight) >= 600;
    const nextItalic =
      italic ||
      ["i", "em"].includes(tag) ||
      (item.style?.fontStyle || computed?.fontStyle) === "italic";
    Array.from(item.childNodes || []).forEach(child =>
      visit(child, nextBold, nextItalic)
    );
  };
  visit(node);
  return runs;
};

const collectContractBlocks = root => {
  const blocks = [];
  const append = (tag, node, prefix = "") => {
    const runs = [...(prefix ? [{ text: prefix }] : []), ...inlineRuns(node)];
    const text = runs.map(run => run.text).join("");
    if (text.trim()) blocks.push({ tag, text, runs });
  };
  const visit = node => {
    let inline = [];
    const flush = () => {
      if (!inline.length) return;
      const runs = inline.flatMap(inlineRuns);
      const text = runs.map(run => run.text).join("");
      if (text.trim()) blocks.push({ tag: "p", text, runs });
      inline = [];
    };
    Array.from(node.childNodes || []).forEach(child => {
      const tag = (child.tagName || "").toLowerCase();
      if (/^h[1-6]$/.test(tag) || tag === "p") {
        flush();
        append(tag, child);
      } else if (tag === "ul" || tag === "ol") {
        flush();
        Array.from(child.children).forEach((item, index) =>
          append("li", item, tag === "ol" ? `${index + 1}. ` : "• ")
        );
      } else if (tag === "table") {
        flush();
        Array.from(child.querySelectorAll("tr")).forEach(row => {
          const runs = Array.from(row.children).flatMap((cell, index) => [
            ...(index ? [{ text: " | " }] : []),
            ...inlineRuns(cell)
          ]);
          blocks.push({
            tag: "p",
            text: runs.map(run => run.text).join(""),
            runs
          });
        });
      } else if (["div", "section", "article"].includes(tag)) {
        flush();
        visit(child);
      } else inline.push(child);
    });
    flush();
  };
  if (root) visit(root);
  return blocks;
};

module.exports = { collectContractBlocks, inlineRuns };
